(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bnb-buy-two-offer"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bnb-multi-buy-offer')) {
    customElements.define(
      'bnb-multi-buy-offer',
      class MultiBuyOffer extends HTMLElement {
        connectedCallback() {
          this.checkbox = this.querySelector('.bnb-buy-two__checkbox');
          this.choices = this.querySelector('.bnb-buy-two__choices');
          this.sharedOption = this.querySelector('[data-shared-option]');
          this.unitRows = Array.from(this.querySelectorAll('[data-unit-row]'));
          this.saving = this.querySelector('[data-offer-saving]');
          this.errorBox = this.querySelector('[data-offer-error]');
          this.form = this.closest('form');
          this.quantity = Number(this.dataset.quantity || 2);
          this.discountPercent = Number(this.dataset.discountPercent || 0);
          this.sharedOptionIndex = Number(this.dataset.sharedOptionIndex || -1);
          this.uniqueVariants = this.dataset.uniqueVariants === 'true';
          this.defaultVariant = this.dataset.defaultVariant === 'true';
          this.variants = this.readVariants();
          this.optionNames = this.readOptionNames();
          this.uniqueOptionIndex = this.findUniqueOptionIndex();
          if (!this.checkbox || !this.form) return;

          this.checkbox.addEventListener('change', () => this.applyOffer());
          this.sharedOption?.addEventListener('change', () => this.handleSharedOptionChange());
          this.unitRows.forEach((row) => {
            row.querySelectorAll('[data-unit-option]').forEach((selector) => {
              selector.addEventListener('change', () => this.handleSelectionChange(row));
            });
          });
          document.addEventListener('variant:changed', (event) => this.syncPrimaryVariant(event));
          this.form.addEventListener('submit', (event) => this.handleSubmit(event), true);

          const buyNow = this.form.querySelector('[data-bnb-buy-now]');
          if (buyNow) {
            buyNow.addEventListener('click', () => this.handleBuyNow());
          }

          this.initializeSelections();
          this.updateSaving();
        }

        get primaryVariantId() {
          return String(this.form.querySelector('input[name="id"]')?.value || '');
        }

        readVariants() {
          try {
            return JSON.parse(this.querySelector('[data-offer-variants]')?.textContent || '[]');
          } catch {
            return [];
          }
        }

        readOptionNames() {
          const names = [];
          const firstRow = this.unitRows[0];
          firstRow?.querySelectorAll('[data-unit-option]').forEach((selector) => {
            names[Number(selector.dataset.optionIndex)] =
              selector.closest('.bnb-buy-two__option')?.querySelector('span')?.textContent.trim() || '';
          });
          if (this.sharedOption && this.sharedOptionIndex >= 0) {
            names[this.sharedOptionIndex] =
              this.sharedOption.closest('.bnb-buy-two__shared')?.querySelector('span')?.textContent.trim() || '';
          }
          return names;
        }

        findUniqueOptionIndex() {
          const preferred = this.optionNames.findIndex((name) =>
            /(design|color|colour|style|print|shade|scent|flavour|flavor)/i.test(name)
          );
          if (preferred >= 0) return preferred;
          const nonSize = this.optionNames.findIndex((name) => !/(size|age)/i.test(name));
          return nonSize >= 0 ? nonSize : 0;
        }

        variantId(variant) {
          return String(variant?.id || '');
        }

        variantAvailable(variant) {
          return Boolean(variant?.available);
        }

        variantOptions(variant) {
          return Array.isArray(variant?.options) ? variant.options.map(String) : [];
        }

        selectorsForRow(row) {
          return Array.from(row.querySelectorAll('[data-unit-option]'));
        }

        selectedOptions(row) {
          const optionCount = Math.max(
            this.optionNames.length,
            this.variants[0]?.options?.length || 0
          );
          const selected = Array(optionCount).fill('');
          if (this.sharedOption && this.sharedOptionIndex >= 0) {
            selected[this.sharedOptionIndex] = this.sharedOption.value;
          }
          this.selectorsForRow(row).forEach((selector) => {
            selected[Number(selector.dataset.optionIndex)] = selector.value;
          });
          return selected;
        }

        variantMatches(variant, options, ignoredIndex = -1) {
          const variantOptions = this.variantOptions(variant);
          return options.every((value, index) => {
            if (index === ignoredIndex || !value) return true;
            return variantOptions[index] === value;
          });
        }

        resolveVariant(row) {
          const options = this.selectedOptions(row);
          return this.variants.find(
            (variant) => this.variantAvailable(variant) && this.variantMatches(variant, options)
          );
        }

        stabilizeRow(row) {
          for (let pass = 0; pass < 3; pass += 1) {
            this.selectorsForRow(row).forEach((selector) => {
              const optionIndex = Number(selector.dataset.optionIndex);
              const currentOptions = this.selectedOptions(row);
              Array.from(selector.options).forEach((option) => {
                const candidateOptions = [...currentOptions];
                candidateOptions[optionIndex] = option.value;
                option.disabled = !this.variants.some(
                  (variant) =>
                    this.variantAvailable(variant) &&
                    this.variantMatches(variant, candidateOptions)
                );
              });
              if (selector.selectedOptions[0]?.disabled) {
                const firstAvailable = Array.from(selector.options).find((option) => !option.disabled);
                if (firstAvailable) selector.value = firstAvailable.value;
              }
            });
          }
          row.dataset.unavailable = String(!this.resolveVariant(row));
        }

        setRowFromVariant(row, variant) {
          if (!row || !variant) return;
          const options = this.variantOptions(variant);
          if (this.sharedOption && this.sharedOptionIndex >= 0 && options[this.sharedOptionIndex]) {
            this.sharedOption.value = options[this.sharedOptionIndex];
          }
          this.selectorsForRow(row).forEach((selector) => {
            const optionIndex = Number(selector.dataset.optionIndex);
            if (options[optionIndex]) selector.value = options[optionIndex];
          });
          this.stabilizeRow(row);
        }

        uniqueKey(variant) {
          const options = this.variantOptions(variant);
          return String(options[this.uniqueOptionIndex] || this.variantId(variant));
        }

        availableVariantsForCurrentSharedOption() {
          return this.variants.filter((variant) => {
            if (!this.variantAvailable(variant)) return false;
            if (!this.sharedOption || this.sharedOptionIndex < 0) return true;
            return this.variantOptions(variant)[this.sharedOptionIndex] === this.sharedOption.value;
          });
        }

        initializeSelections() {
          if (this.defaultVariant) return;
          const primaryVariant = this.variants.find(
            (variant) => this.variantId(variant) === this.primaryVariantId
          );
          if (primaryVariant) this.setRowFromVariant(this.unitRows[0], primaryVariant);

          const used = new Set();
          this.unitRows.forEach((row, index) => {
            if (index === 0) {
              const firstVariant = this.resolveVariant(row);
              if (this.uniqueVariants && firstVariant) used.add(this.uniqueKey(firstVariant));
              this.stabilizeRow(row);
              return;
            }

            if (this.uniqueVariants) {
              const candidate = this.availableVariantsForCurrentSharedOption().find(
                (variant) => !used.has(this.uniqueKey(variant))
              );
              if (candidate) {
                this.setRowFromVariant(row, candidate);
                used.add(this.uniqueKey(candidate));
              }
            } else if (primaryVariant) {
              this.setRowFromVariant(row, primaryVariant);
            }
            this.stabilizeRow(row);
          });
        }

        syncPrimaryVariant(event) {
          const variantId = String(event.detail?.variant?.id || '');
          if (!variantId || this.defaultVariant) return;
          const variant = this.variants.find((item) => this.variantId(item) === variantId);
          if (!variant) return;
          if (!this.checkbox.checked) {
            this.setRowFromVariant(this.unitRows[0], variant);
            if (this.sharedOption && this.sharedOptionIndex >= 0) {
              this.unitRows.forEach((row) => this.stabilizeRow(row));
            }
          }
          this.updateSaving();
        }

        handleSharedOptionChange() {
          this.unitRows.forEach((row) => this.stabilizeRow(row));
          this.ensureUniqueSelections();
          this.clearError();
          this.updateSaving();
        }

        handleSelectionChange(row) {
          this.stabilizeRow(row);
          this.clearError();
          this.updateSaving();
        }

        ensureUniqueSelections() {
          if (!this.uniqueVariants) return;
          const used = new Set();
          this.unitRows.forEach((row) => {
            let variant = this.resolveVariant(row);
            if (!variant || used.has(this.uniqueKey(variant))) {
              variant = this.availableVariantsForCurrentSharedOption().find(
                (candidate) => !used.has(this.uniqueKey(candidate))
              );
              if (variant) this.setRowFromVariant(row, variant);
            }
            if (variant) used.add(this.uniqueKey(variant));
          });
        }

        applyOffer() {
          this.choices.hidden = !this.checkbox.checked;
          this.clearError();
          if (this.checkbox.checked) {
            this.unitRows.forEach((row) => this.stabilizeRow(row));
            this.ensureUniqueSelections();
          }
          this.updateSaving();
        }

        selectedEntries() {
          if (this.defaultVariant) {
            return Array.from({ length: this.quantity }, () => ({
              id: this.primaryVariantId,
              title: this.dataset.defaultTitle,
              price: Number(this.dataset.selectedPrice || 0),
              options: []
            }));
          }

          return this.unitRows.map((row) => {
            const variant = this.resolveVariant(row);
            return {
              id: this.variantId(variant),
              title: String(variant?.title || ''),
              price: Number(variant?.price || 0),
              options: this.variantOptions(variant)
            };
          });
        }

        validateSelections(entries) {
          if (entries.length !== this.quantity || entries.some((entry) => !entry.id)) {
            throw new Error(this.dataset.selectionError);
          }
          if (
            this.uniqueVariants &&
            new Set(entries.map((entry) => String(entry.options[this.uniqueOptionIndex] || entry.id))).size !==
              entries.length
          ) {
            throw new Error(this.dataset.uniqueError);
          }
        }

        selectedSavingCents() {
          if (this.defaultVariant) {
            const price = Number(this.dataset.selectedPrice || 0);
            return Math.round((price * this.quantity * this.discountPercent) / 100);
          }
          const total = this.selectedEntries().reduce((sum, entry) => sum + entry.price, 0);
          return Math.round((total * this.discountPercent) / 100);
        }

        formatMoney(cents) {
          const amount = Math.round(cents / 100);
          return `${this.dataset.moneyPrefix} ${amount.toLocaleString('en-PK')}`;
        }

        updateSaving() {
          if (!this.saving) return;
          this.saving.textContent = `${this.dataset.saveLabel} ${this.formatMoney(this.selectedSavingCents())}`;
        }

        selectionSummary(entries) {
          const grouped = new Map();
          entries.forEach((entry) => {
            const current = grouped.get(entry.title) || 0;
            grouped.set(entry.title, current + 1);
          });
          return Array.from(grouped.entries())
            .map(([title, count]) => `${count} × ${title}`)
            .join(', ');
        }

        buildItems() {
          const entries = this.selectedEntries();
          this.validateSelections(entries);
          const bundleId = `bnb-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
          const summary = this.selectionSummary(entries);
          const heading =
            this.querySelector('.bnb-buy-two__copy strong')?.textContent.trim() ||
            `Buy ${this.quantity} and save ${this.discountPercent}%`;
          const grouped = new Map();

          entries.forEach((entry) => {
            const current = grouped.get(entry.id) || { ...entry, quantity: 0 };
            current.quantity += 1;
            grouped.set(entry.id, current);
          });

          return Array.from(grouped.values()).map((entry, index) => {
            const properties = {
              '_bnb_bundle_id': bundleId,
              '_bnb_bundle_role': index === 0 ? 'primary' : 'secondary',
              '_bnb_offer_quantity': String(this.quantity),
              '_bnb_offer_percent': String(this.discountPercent),
              '_bnb_offer_code': `BNB-MULTI-${this.discountPercent}`,
              '_bnb_offer_title': heading,
              '_bnb_offer_summary': summary,
              '_bnb_pair_1': entries[0]?.title || '',
              '_bnb_pair_2': entries[1]?.title || entries[0]?.title || ''
            };
            if (index === 0) {
              properties[this.dataset.checkoutSavingsLabel] =
                `${this.formatMoney(this.selectedSavingCents())} ${this.dataset.checkoutSavingsSuffix}`;
            }
            return {
              id: Number(entry.id),
              quantity: entry.quantity,
              properties
            };
          });
        }

        async syncDiscounts(cart) {
          const codes = Array.from(
            new Set(
              (cart.items || [])
                .map((item) => item.properties?._bnb_offer_code)
                .filter(Boolean)
            )
          ).sort();
          const signature = codes.join(',');
          const response = await fetch(`${this.dataset.cartUrl}/update.js`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({
              discount: signature,
              attributes: { '_bnb_discount_signature': signature }
            })
          });
          if (!response.ok) throw new Error(this.dataset.addError);
          return response.json();
        }

        handleSubmit(event) {
          if (!this.checkbox.checked) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          this.addOffer(false);
        }

        handleBuyNow() {
          if (this.checkbox.checked) {
            this.addOffer(true);
            return;
          }
          this.addSingleAndCheckout();
        }

        async addSingleAndCheckout() {
          const data = new FormData(this.form);
          try {
            const response = await fetch(
              this.dataset.addUrl.endsWith('.js') ? this.dataset.addUrl : `${this.dataset.addUrl}.js`,
              {
                method: 'POST',
                headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
                body: data
              }
            );
            if (!response.ok) throw new Error(this.dataset.addError);
            window.location.assign('/checkout');
          } catch (error) {
            this.showError(error.message);
          }
        }

        setBusy(busy) {
          this.form.querySelectorAll('button').forEach((button) => {
            button.disabled = busy;
          });
        }

        clearError() {
          if (!this.errorBox) return;
          this.errorBox.hidden = true;
          this.errorBox.textContent = '';
        }

        showError(message) {
          if (!this.errorBox) return;
          this.errorBox.textContent = message;
          this.errorBox.hidden = false;
        }

        async addOffer(goToCheckout) {
          this.setBusy(true);
          this.clearError();

          try {
            const addUrl = this.dataset.addUrl.endsWith('.js')
              ? this.dataset.addUrl
              : `${this.dataset.addUrl}.js`;
            const response = await fetch(addUrl, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
              },
              body: JSON.stringify({ items: this.buildItems() })
            });
            const result = await response.json().catch(() => ({}));
            if (!response.ok) {
              throw new Error(result.description || result.message || this.dataset.addError);
            }

            const cartResponse = await fetch(`${this.dataset.cartUrl}.js`, {
              headers: { Accept: 'application/json' }
            });
            const initialCart = await cartResponse.json();
            const cart = await this.syncDiscounts(initialCart);

            if (goToCheckout) {
              window.location.assign('/checkout');
              return;
            }

            const cartCount = Number(cart.item_count || 0);
            document.querySelectorAll('cart-count').forEach((badge) => {
              badge.hidden = cartCount < 1;
              badge.classList.toggle('cart-count--small-medium', cartCount > 99);
              badge.setAttribute('aria-label', `Cart items: ${cartCount}`);
              badge.textContent = cartCount > 99 ? '99+' : String(cartCount);
            });
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
            document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
            this.setBusy(false);
          } catch (error) {
            this.setBusy(false);
            this.showError(error.message);
          }
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bnb-starter-set-group-offer"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bnb-starter-group-offer')) {
    customElements.define(
      'bnb-starter-group-offer',
      class StarterGroupOffer extends HTMLElement {
        connectedCallback() {
          if (this.dataset.initialized === 'true') return;
          this.dataset.initialized = 'true';

          this.checkbox = this.querySelector('.bnb-starter-group-offer__checkbox');
          this.panel = this.querySelector('[data-offer-panel]');
          this.progress = this.querySelector('[data-offer-progress]');
          this.picksWrap = this.querySelector('[data-picks-wrap]');
          this.picks = this.querySelector('[data-selected-picks]');
          this.summary = this.querySelector('[data-offer-summary]');
          this.readyNote = this.querySelector('[data-ready-note]');
          this.errorBox = this.querySelector('[data-offer-error]');
          this.form = this.closest('form');
          this.submitButton = this.form?.querySelector('.product-form__submit');
          this.submitText = this.submitButton?.querySelector('span');
          this.buyNow = this.form?.querySelector('[data-bnb-buy-now]');
          this.quantity = Number(this.dataset.quantity || 2);
          this.discountPercent = Number(this.dataset.discountPercent || 10);
          this.offerAvailable = this.dataset.offerAvailable === 'true';
          this.currentProductId = String(this.dataset.currentProductId || '');
          this.products = this.readProducts();
          this.productMap = new Map(this.products.map((item) => [String(item.id), item]));
          this.variantState = new Map();
          this.selectedProductIds = [];
          this.designButtons = Array.from(this.querySelectorAll('[data-group-design]'));
          this.originalSubmitText = this.submitText?.textContent.trim() || 'Add to cart';
          this.originalSubmitDisabled = Boolean(this.submitButton?.disabled);
          this.originalBuyNowText = this.buyNow?.textContent.trim() || 'Buy it now';
          this.originalBuyNowDisabled = Boolean(this.buyNow?.disabled);

          if (!this.checkbox || !this.form) return;

          this.checkbox.addEventListener('change', () => this.handleOfferToggle());
          this.designButtons.forEach((button) => {
            button.addEventListener('click', () => this.toggleDesign(button.dataset.productId));
          });
          this.picks?.addEventListener('change', (event) => this.handleOptionChange(event));
          this.form.addEventListener('submit', (event) => this.handleSubmit(event), true);
          this.buyNow?.addEventListener('click', () => this.handleBuyNow());

          this.preselectCurrentProduct();
          this.render();
        }

        readProducts() {
          try {
            const parsed = JSON.parse(this.querySelector('[data-group-products]')?.textContent || '[]');
            return parsed.map((product) => ({
              ...product,
              id: String(product.id),
              defaultVariantId: String(product.defaultVariantId || ''),
              variants: Array.isArray(product.variants)
                ? product.variants.map((variant) => ({
                    ...variant,
                    id: String(variant.id),
                    price: Number(variant.price || 0),
                    available: Boolean(variant.available),
                    options: Array.isArray(variant.options) ? variant.options.map(String) : []
                  }))
                : [],
              options: Array.isArray(product.options) ? product.options : []
            }));
          } catch (error) {
            console.error('[BNB Starter Group Offer] Invalid product data', error);
            return [];
          }
        }

        availableVariants(product) {
          return (product?.variants || []).filter((variant) => variant.available);
        }

        productIsAvailable(product) {
          return this.availableVariants(product).length > 0;
        }

        preselectCurrentProduct() {
          const current = this.productMap.get(this.currentProductId);
          if (current && this.productIsAvailable(current)) {
            this.selectedProductIds = [this.currentProductId];
            this.ensureProductState(current);
          }
        }

        handleOfferToggle() {
          const active = this.checkbox.checked && this.offerAvailable;
          this.dataset.active = String(active);
          this.panel.hidden = !active;
          this.clearError();

          if (active && this.selectedProductIds.length === 0) {
            this.preselectCurrentProduct();
          }

          this.render();
        }

        toggleDesign(productId) {
          if (!this.checkbox.checked) return;
          const id = String(productId || '');
          const product = this.productMap.get(id);
          if (!product || !this.productIsAvailable(product)) return;

          this.clearError();
          const existingIndex = this.selectedProductIds.indexOf(id);

          if (existingIndex >= 0) {
            this.selectedProductIds.splice(existingIndex, 1);
            this.render();
            return;
          }

          if (this.selectedProductIds.length >= this.quantity) {
            this.showError(this.dataset.maxError);
            return;
          }

          this.selectedProductIds.push(id);
          this.ensureProductState(product);
          this.render();
        }

        ensureProductState(product) {
          const id = String(product.id);
          const existing = this.variantState.get(id);
          if (existing) return existing;

          const available = this.availableVariants(product);
          const preferred =
            available.find((variant) => String(variant.id) === String(product.defaultVariantId)) || available[0];

          const state = {
            variantId: String(preferred?.id || ''),
            options: Array.isArray(preferred?.options) ? [...preferred.options] : []
          };
          this.variantState.set(id, state);
          return state;
        }

        resolvedVariant(product) {
          const available = this.availableVariants(product);
          if (!available.length) return null;

          const state = this.ensureProductState(product);
          let variant = available.find((candidate) =>
            candidate.options.every((value, index) => String(value) === String(state.options[index] || ''))
          );

          if (!variant) {
            variant = available.find((candidate) => String(candidate.id) === String(state.variantId)) || available[0];
            state.variantId = String(variant.id);
            state.options = [...variant.options];
          }

          return variant;
        }

        varyingOptionValues(product, optionIndex) {
          return Array.from(
            new Set(
              this.availableVariants(product)
                .map((variant) => String(variant.options[optionIndex] || ''))
                .filter(Boolean)
            )
          );
        }

        optionValueAvailable(product, optionIndex, value) {
          const state = this.ensureProductState(product);
          return this.availableVariants(product).some((variant) => {
            if (String(variant.options[optionIndex] || '') !== String(value)) return false;
            return variant.options.every((optionValue, index) => {
              if (index === optionIndex) return true;
              const selected = String(state.options[index] || '');
              return !selected || String(optionValue) === selected;
            });
          });
        }

        handleOptionChange(event) {
          const select = event.target.closest('[data-group-option]');
          if (!select) return;

          const productId = String(select.dataset.productId || '');
          const product = this.productMap.get(productId);
          if (!product) return;

          const optionIndex = Number(select.dataset.optionIndex);
          const state = this.ensureProductState(product);
          state.options[optionIndex] = select.value;

          let variant = this.availableVariants(product).find((candidate) =>
            candidate.options.every((value, index) => String(value) === String(state.options[index] || ''))
          );

          if (!variant) {
            variant = this.availableVariants(product).find(
              (candidate) => String(candidate.options[optionIndex] || '') === String(select.value)
            );
          }

          if (variant) {
            state.variantId = String(variant.id);
            state.options = [...variant.options];
          }

          this.clearError();
          this.render();
        }

        render() {
          this.renderDesignStates();
          this.renderProgress();
          this.renderSelectedPicks();
          this.renderSummary();
          this.updateActionButtons();
        }

        renderDesignStates() {
          this.designButtons.forEach((button) => {
            const selected = this.selectedProductIds.includes(String(button.dataset.productId || ''));
            button.classList.toggle('is-selected', selected);
            button.setAttribute('aria-pressed', String(selected));
          });
        }

        renderProgress() {
          if (!this.progress) return;
          const count = this.selectedProductIds.length;
          const ready = this.isReady();
          this.progress.textContent = ready
            ? `${count} of ${this.quantity} selected · Ready`
            : `${count} of ${this.quantity} selected`;
          this.progress.classList.toggle('is-ready', ready);
        }

        renderSelectedPicks() {
          if (!this.picks || !this.picksWrap) return;
          const selectedProducts = this.selectedProductIds
            .map((id) => this.productMap.get(id))
            .filter(Boolean);

          this.picksWrap.hidden = selectedProducts.length === 0;
          this.picks.innerHTML = selectedProducts.map((product) => this.pickMarkup(product)).join('');
        }

        pickMarkup(product) {
          const variant = this.resolvedVariant(product);
          if (!variant) return '';
          const state = this.ensureProductState(product);
          const controls = [];
          const fixed = [];

          (product.options || []).forEach((option, optionIndex) => {
            const values = this.varyingOptionValues(product, optionIndex);
            const optionName = String(option?.name || `Option ${optionIndex + 1}`);

            if (values.length > 1) {
              const optionsMarkup = values
                .map((value) => {
                  const disabled = !this.optionValueAvailable(product, optionIndex, value);
                  const selected = String(state.options[optionIndex] || '') === String(value);
                  return `<option value="${this.escapeHtml(value)}"${selected ? ' selected' : ''}${disabled ? ' disabled' : ''}>${this.escapeHtml(value)}</option>`;
                })
                .join('');

              controls.push(`
                <label class="bnb-starter-group-offer__option-control">
                  <span>${this.escapeHtml(optionName)}</span>
                  <select data-group-option data-product-id="${this.escapeHtml(product.id)}" data-option-index="${optionIndex}">
                    ${optionsMarkup}
                  </select>
                </label>
              `);
            } else if (values.length === 1 && /(size|age)/i.test(optionName)) {
              fixed.push(`
                <span class="bnb-starter-group-offer__fixed-option">
                  ${this.escapeHtml(optionName)}: <strong>${this.escapeHtml(values[0])}</strong>
                </span>
              `);
            }
          });

          return `
            <div class="bnb-starter-group-offer__pick" data-selected-product="${this.escapeHtml(product.id)}">
              <div class="bnb-starter-group-offer__pick-image">
                ${product.image ? `<img src="${this.escapeHtml(product.image)}" alt="" loading="lazy">` : ''}
              </div>
              <div class="bnb-starter-group-offer__pick-body">
                <div class="bnb-starter-group-offer__pick-top">
                  <div class="bnb-starter-group-offer__pick-copy">
                    <span class="bnb-starter-group-offer__pick-status">SELECTED DESIGN</span>
                    <span class="bnb-starter-group-offer__pick-title">${this.escapeHtml(product.title)}</span>
                  </div>
                  <strong class="bnb-starter-group-offer__pick-price">${this.formatMoney(variant.price)}</strong>
                </div>
                ${fixed.length ? `<div class="bnb-starter-group-offer__fixed-options">${fixed.join('')}</div>` : ''}
                ${controls.length ? `<div class="bnb-starter-group-offer__option-controls">${controls.join('')}</div>` : ''}
              </div>
            </div>
          `;
        }

        renderSummary() {
          if (!this.summary || !this.readyNote) return;
          if (!this.isReady()) {
            const remaining = Math.max(this.quantity - this.selectedProductIds.length, 0);
            this.summary.innerHTML = `
              <div class="bnb-starter-group-offer__summary-wait">
                <span class="bnb-starter-group-offer__summary-icon" aria-hidden="true">✓</span>
                <span>${remaining > 0 ? `Choose ${remaining} more design${remaining === 1 ? '' : 's'} to see your bundle total.` : 'Confirm all options to continue.'}</span>
              </div>
            `;
            this.readyNote.hidden = true;
            return;
          }

          const entries = this.selectedEntries();
          const subtotal = entries.reduce((sum, entry) => sum + entry.price, 0);
          const saving = Math.round((subtotal * this.discountPercent) / 100);
          const total = subtotal - saving;

          this.summary.innerHTML = `
            <div class="bnb-starter-group-offer__totals">
              <div class="bnb-starter-group-offer__total-row">
                <span>2 selected items</span>
                <strong>${this.formatMoney(subtotal)}</strong>
              </div>
              <div class="bnb-starter-group-offer__total-row is-saving">
                <span>You save (${this.discountPercent}%)</span>
                <strong>− ${this.formatMoney(saving)}</strong>
              </div>
              <div class="bnb-starter-group-offer__total-row is-final">
                <span>Bundle total</span>
                <strong>${this.formatMoney(total)}</strong>
              </div>
            </div>
          `;
          this.readyNote.hidden = false;
        }

        selectedEntries() {
          return this.selectedProductIds.map((productId) => {
            const product = this.productMap.get(productId);
            const variant = this.resolvedVariant(product);
            const sizeIndex = (product?.options || []).findIndex((option) => /(size|age)/i.test(String(option?.name || '')));
            const sizeValue = sizeIndex >= 0 ? String(variant?.options?.[sizeIndex] || '') : '';
            const summaryTitle = sizeValue ? `${product.title} · Size ${sizeValue}` : product.title;
            return {
              id: String(variant?.id || ''),
              productId: String(product?.id || ''),
              title: String(product?.title || ''),
              summaryTitle,
              price: Number(variant?.price || 0),
              variant
            };
          });
        }

        validateEntries(entries) {
          if (entries.length !== this.quantity || entries.some((entry) => !entry.id || !entry.variant?.available)) {
            throw new Error(this.dataset.variantError || this.dataset.selectionError);
          }
          if (new Set(entries.map((entry) => entry.productId)).size !== this.quantity) {
            throw new Error(this.dataset.selectionError);
          }
        }

        isReady() {
          if (!this.checkbox?.checked || !this.offerAvailable) return false;
          if (this.selectedProductIds.length !== this.quantity) return false;
          try {
            const entries = this.selectedEntries();
            this.validateEntries(entries);
            return true;
          } catch {
            return false;
          }
        }

        selectionSummary(entries) {
          return entries.map((entry) => `1 × ${entry.summaryTitle}`).join(', ');
        }

        selectedSavingCents() {
          const subtotal = this.selectedEntries().reduce((sum, entry) => sum + entry.price, 0);
          return Math.round((subtotal * this.discountPercent) / 100);
        }

        buildItems() {
          const entries = this.selectedEntries();
          this.validateEntries(entries);
          const bundleId = `bnb-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
          const summary = this.selectionSummary(entries);
          const offerTitle = this.dataset.offerTitle || `Buy ${this.quantity} and save ${this.discountPercent}%`;

          return entries.map((entry, index) => {
            const properties = {
              '_bnb_bundle_id': bundleId,
              '_bnb_bundle_role': index === 0 ? 'primary' : 'secondary',
              '_bnb_offer_quantity': String(this.quantity),
              '_bnb_offer_percent': String(this.discountPercent),
              '_bnb_offer_code': `BNB-MULTI-${this.discountPercent}`,
              '_bnb_offer_title': offerTitle,
              '_bnb_offer_summary': summary,
              '_bnb_pair_1': entries[0]?.summaryTitle || '',
              '_bnb_pair_2': entries[1]?.summaryTitle || entries[0]?.summaryTitle || ''
            };

            if (index === 0 && this.dataset.checkoutSavingsLabel) {
              properties[this.dataset.checkoutSavingsLabel] =
                `${this.formatMoney(this.selectedSavingCents())} ${this.dataset.checkoutSavingsSuffix || ''}`.trim();
            }

            return {
              id: Number(entry.id),
              quantity: 1,
              properties
            };
          });
        }

        async syncDiscounts(cart) {
          const codes = Array.from(
            new Set(
              (cart.items || [])
                .map((item) => item.properties?._bnb_offer_code)
                .filter(Boolean)
            )
          ).sort();
          const signature = codes.join(',');
          const response = await fetch(`${this.dataset.cartUrl}/update.js`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({
              discount: signature,
              attributes: { '_bnb_discount_signature': signature }
            })
          });
          if (!response.ok) throw new Error(this.dataset.addError || 'Unable to apply the bundle discount.');
          return response.json();
        }

        handleSubmit(event) {
          if (!this.checkbox.checked) return;
          event.preventDefault();
          event.stopImmediatePropagation();

          if (!this.isReady()) {
            this.showError(this.dataset.selectionError);
            return;
          }

          this.addOffer(false);
        }

        handleBuyNow() {
          if (this.checkbox.checked) {
            if (!this.isReady()) {
              this.showError(this.dataset.selectionError);
              return;
            }
            this.addOffer(true);
            return;
          }
          this.addSingleAndCheckout();
        }

        async addSingleAndCheckout() {
          const data = new FormData(this.form);
          this.setBusy(true);
          this.clearError();
          try {
            const addUrl = this.dataset.addUrl.endsWith('.js') ? this.dataset.addUrl : `${this.dataset.addUrl}.js`;
            const response = await fetch(addUrl, {
              method: 'POST',
              headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
              body: data
            });
            if (!response.ok) throw new Error(this.dataset.addError || 'Unable to add this item.');
            window.location.assign('/checkout');
          } catch (error) {
            this.setBusy(false);
            this.showError(error.message);
          }
        }

        async addOffer(goToCheckout) {
          this.setBusy(true);
          this.clearError();

          try {
            const addUrl = this.dataset.addUrl.endsWith('.js') ? this.dataset.addUrl : `${this.dataset.addUrl}.js`;
            const response = await fetch(addUrl, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
              },
              body: JSON.stringify({ items: this.buildItems() })
            });
            const result = await response.json().catch(() => ({}));
            if (!response.ok) {
              throw new Error(result.description || result.message || this.dataset.addError || 'Unable to add the bundle.');
            }

            const cartResponse = await fetch(`${this.dataset.cartUrl}.js`, {
              headers: { Accept: 'application/json' }
            });
            const initialCart = await cartResponse.json();
            const cart = await this.syncDiscounts(initialCart);

            if (goToCheckout) {
              window.location.assign('/checkout');
              return;
            }

            const cartCount = Number(cart.item_count || 0);
            document.querySelectorAll('cart-count').forEach((badge) => {
              badge.hidden = cartCount < 1;
              badge.classList.toggle('cart-count--small-medium', cartCount > 99);
              badge.setAttribute('aria-label', `Cart items: ${cartCount}`);
              badge.textContent = cartCount > 99 ? '99+' : String(cartCount);
            });
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
            document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
            this.setBusy(false);
          } catch (error) {
            this.setBusy(false);
            this.showError(error.message);
          }
        }

        updateActionButtons() {
          if (!this.submitButton) return;
          const active = this.checkbox.checked && this.offerAvailable;
          const ready = this.isReady();

          if (!active) {
            this.submitButton.disabled = this.originalSubmitDisabled;
            if (this.submitText) this.submitText.textContent = this.originalSubmitText;
            if (this.buyNow) {
              this.buyNow.disabled = this.originalBuyNowDisabled;
              this.buyNow.textContent = this.originalBuyNowText;
            }
            return;
          }

          this.submitButton.disabled = !ready;
          if (this.submitText) {
            this.submitText.textContent = ready
              ? `Add ${this.quantity} to cart · Save ${this.discountPercent}%`
              : `Select ${this.quantity} designs`;
          }

          if (this.buyNow) {
            this.buyNow.disabled = !ready;
            this.buyNow.textContent = ready
              ? `Buy ${this.quantity} now · Save ${this.discountPercent}%`
              : `Choose ${this.quantity} designs`;
          }
        }

        setBusy(busy) {
          this.dataset.busy = String(busy);
          if (busy) {
            if (this.submitButton) this.submitButton.disabled = true;
            if (this.buyNow) this.buyNow.disabled = true;
          } else {
            this.updateActionButtons();
          }
        }

        formatMoney(cents) {
          const amount = Number(cents || 0) / 100;
          const hasDecimals = Math.abs(amount - Math.round(amount)) > 0.001;
          const formatted = amount.toLocaleString('en-PK', {
            minimumFractionDigits: hasDecimals ? 2 : 0,
            maximumFractionDigits: 2
          });
          const prefix = this.dataset.moneyPrefix || 'Rs.';
          return `${prefix} ${formatted}`.trim();
        }

        escapeHtml(value) {
          return String(value ?? '')
            .replaceAll('&', '&amp;')
            .replaceAll('<', '&lt;')
            .replaceAll('>', '&gt;')
            .replaceAll('"', '&quot;')
            .replaceAll("'", '&#039;');
        }

        clearError() {
          if (!this.errorBox) return;
          this.errorBox.hidden = true;
          this.errorBox.textContent = '';
        }

        showError(message) {
          if (!this.errorBox) return;
          this.errorBox.textContent = message || 'Please complete your bundle selection.';
          this.errorBox.hidden = false;
          this.errorBox.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
